import { Col, Input, Row, Space } from 'antd';
import { FC } from 'react';
import { CancelIcon, SearchSvg } from 'utils/svgs';
import styles from './index.module.scss';
import { StaffSearchAndFilterProps } from './types';

const SearchAndFilter: FC<StaffSearchAndFilterProps> = (props) => {
	const {
		performSearchHandler,
		searchValue,
		title,
		isSearchCancel,
		setSearch,
		setIsSearchCancel,
	} = props;

	return (
		<div className={styles['search-filter']}>
			<div className={styles['search-filter__wrapper']}>
				<Row justify={'space-between'}>
					<Col>
						<div className={styles['search-filter__wrapper--title']}>
							{title}
						</div>
					</Col>
					<Col>
						<Space>
							<Input
								className={styles['search-filter__search']}
								placeholder="Search by Name and Email"
								prefix={<SearchSvg />}
								onChange={performSearchHandler}
								value={searchValue}
								size="large"
								suffix={
									isSearchCancel && (
										<span
											style={{ display: 'flex', cursor: 'pointer' }}
											onClick={() => {
												setSearch('');
												setIsSearchCancel(false);
											}}
										>
											<CancelIcon />
										</span>
									)
								}
							/>
						</Space>
					</Col>
				</Row>
			</div>
		</div>
	);
};

export default SearchAndFilter;
